module.exports = __webpack_public_path__ + "img/q5-1-1@2x.3577893f.png";